import React from 'react';
import PropTypes from 'prop-types';
import Paragraph from './Paragraph/Paragraph';
import { formatBirthday } from '../util/helpers/reviewHelper';
import themeColors from '../assets/styles/themeColors';
import MissingInfo from '../pages/Review/MissingInfo';

const Birthday = ({ DateOfBirth }) => {
  const date = new Date(DateOfBirth);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const isEmptyDOB = !DateOfBirth;

  if (isEmptyDOB) {
    return <MissingInfo />;
  }
  if (!day || !month || !year) {
    return (
      <Paragraph color={themeColors.colorTextXLLight} variant="normal">
        N/A
      </Paragraph>
    );
  }
  return (
    <Paragraph color={themeColors.colorTextXLLight} variant="normal">
      {formatBirthday(month, day, year)}
    </Paragraph>
  );
};

Birthday.propTypes = {
  DateOfBirth: PropTypes.string,
};

export default Birthday;
